import { LoadingButton } from '@mui/lab';
import { Box, Button, Grid } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import { FormProvider, RHFSwitch, RHFTextField } from 'src/components/hook-form';
import { APP_VERSION_CONTROL_LIST } from 'src/constants/queryKeys';
import useFormsModalStore from 'src/store/forms';
import { getDefaultValues } from './defaultValues';
import { networkCreateAppVersionControl, networkUpdateAppVersionControl } from 'src/network/app-version-control-list';

const AppVerstionControlForm = () => {
  const { modal, closeModal } = useFormsModalStore();

  const { enqueueSnackbar } = useSnackbar();

  const queryClient = useQueryClient();

  const exchangeConfigDetails = modal?.data;
  const defaultValues = getDefaultValues(exchangeConfigDetails);
  const isEditMode = exchangeConfigDetails;

  const methods = useForm({
    // resolver: yupResolver(schema), // todo schema
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  // ---------------------------------------------------------------

  const onSubmit = async (values, event) => {
    const PAYLOAD = {
      ...values,
      AppVersionControlVersionApp: +values?.AppVersionControlVersionApp,
      AppVersionControlVersionVideo: +values?.AppVersionControlVersionVideo,
      AppVersionControlIsForceUpdate: values?.AppVersionControlIsForceUpdate ? 1 : 0,
    };

    try {
      if (isEditMode) {
        const res = await networkUpdateAppVersionControl(exchangeConfigDetails?.AppVersionControlID, PAYLOAD);
        if (res.data?.items?.ResultID !== -1) {
          enqueueSnackbar('آیتم موردنظر با موفقیت ویرایش شد');
          if (event.nativeEvent.submitter.name === 'save') {
            closeModal();
            reset();
            await queryClient.invalidateQueries([APP_VERSION_CONTROL_LIST]);
          }
        } else {
          enqueueSnackbar('خطایی رخ داد !', { variant: 'error' });
        }
      } else {
        const res = await networkCreateAppVersionControl(PAYLOAD);
        if (res.data?.items?.ResultID !== -1) {
          enqueueSnackbar('آیتم موردنظر با موفقیت ایجاد شد');
          if (event.nativeEvent.submitter.name === 'save') {
            closeModal();
          }
          reset();
          await queryClient.invalidateQueries([APP_VERSION_CONTROL_LIST]);
        } else {
          enqueueSnackbar('خطایی رخ داد !', { variant: 'error' });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box sx={{ p: 3 }}>
            <Box
              sx={{
                display: 'grid',
                columnGap: 2,
                rowGap: 3,
                gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
              }}
            >
              <RHFTextField name="AppVersionControlLable" type="text" label="عنوان" />

              <RHFTextField name="AppVersionControlPackageName" type="text" label="نام پکیج" />

              <RHFTextField name="AppVersionControlUrlDownloadApp" type="text" label="لینک دانلود اپ" />

              <RHFTextField name="AppVersionControlUrlPlayVideo" type="text" label="لینک ویدیو" />

              <RHFTextField name="AppVersionControlVersionApp" type="text" label="ورژن اپ" />

              <RHFTextField name="AppVersionControlVersionVideo" type="text" label="نسخه ویدیو" />
            </Box>

            <Box
              sx={{
                mt: 3,
                display: 'grid',
                columnGap: 2,
                rowGap: 3,
                gridTemplateColumns: { xs: 'repeat(1, 1fr)' },
              }}
            >
              <RHFTextField name="AppVersionControlChangeLog" multiline rows={6} label="تغییرات نسخه" />

              <RHFSwitch name="AppVersionControlIsForceUpdate" labelPlacement="end" label="نیاز به آپدیت ضروی" />
            </Box>

            <div className="flex items-center gap-4 mt-6">
              <LoadingButton type="submit" variant="contained" name="save" loading={isSubmitting}>
                ذخیره
              </LoadingButton>
              <LoadingButton type="submit" variant="contained" color="info" name="saveAndContinue" loading={isSubmitting}>
                {isEditMode ? 'ذخیره و ادامه ویرایش' : 'ذخیره و ایجاد بعدی'}
              </LoadingButton>
              <Button onClick={closeModal} variant="contained" color="error">
                انصراف
              </Button>
            </div>
          </Box>
        </Grid>
      </Grid>
    </FormProvider>
  );
};

export default AppVerstionControlForm;
